import React, { Component } from 'react';
import {
  imageBasePath,
  dualPedigreeMode,
  dualPedigreeLaunchOnDev,
  scaleDownDesktopIcon,
} from '../../library/constants';
import './index.css';
import {
  isMobilePhone,
  isAndroidTablet,
} from '../../library/calc';

import Pdf from './pdf';
/*

dualPedigreeButterfly


 */
class PrintTree extends Pdf {
// class PrintTree extends Component {
  dualPedigreePanel = true;
  printDualPedigreeTree(){

    this.props.showProgressIndicator();
    this.props.setHighResolutionImagesForDualPedigree(true);

  }

  render () {

    const {
      setPrintModalVisible,
      hideProductTour,
      isDualPedigree,
    } = this.props;

    const isDual = isDualPedigree || dualPedigreeMode || dualPedigreeLaunchOnDev;

    const desktopPrintIconRight =  isDual ? 50 : 150;


    let side = (!isMobilePhone() ? 60: 46);

    let backgroundSize = (!isMobilePhone() ? 55: 43);

    let printTreeStyle = {
      scale: scaleDownDesktopIcon,
      right: `${(!isMobilePhone() ? desktopPrintIconRight: 15)}px`,
      bottom: `${(!isMobilePhone() ? 36: 81)}px`,
      backgroundRepeat: `no-repeat`,
      backgroundSize: `${backgroundSize}px`,
      backgroundColor: 'white',
      backgroundPosition: '2px 2px',
      border: '1px solid #C0C0C0',
      width: `${side}px`,
      height: `${side}px`,
      position: 'absolute',
      opacity: .6,
      cursor: 'pointer',
      MozBoxShadow: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
      webKitboxShadow: '0 4px 8px 0 rgba(0,0,0,0.12),  0 2px 4px 0 rgba(0,0,0,0.08)',
      boxShadow: '0 4px 8px 0 rgba(0,0,0,0.12),  0 2px 4px 0 rgba(0,0,0,0.08)',
      backgroundImage: `url(${imageBasePath}${( isDual  ? 'download': 'printer' )}.svg?${this.props.clearImgCache})`,
    };


   if( isAndroidTablet() ) {

      let side  = 38;

      delete printTreeStyle['top'];

      printTreeStyle = {
        ...printTreeStyle,
        bottom:  `${ 37 }px`,
        width: `${ side }px`,
        height: `${ side }px`,
        backgroundSize: `${ side - 5 }px`,
      };

    }

    return (
      <div >
        <div style={{
          display: 'none'}}
        >
          <img
            id='genilogo'
            alt='genilogo'
            src={`${imageBasePath}Geni_Logo.png`}
          />
          <canvas
              id="legendCanvas"
              width="500"
              height="400" >
          </canvas>
          <img
              id='legendImg'
              alt='legendImg'
              style={{
                width: '500px',
                height: '400px',
                background: 'white',
              }}
          />
        </div>
        <div
          id={'printTreeIcon'}
          style={printTreeStyle}
          onClick={
            ()=>{
              if( isDualPedigree || dualPedigreeMode || dualPedigreeLaunchOnDev  ){
                this.printDualPedigreeTree();
              } else {


                if(this.props.chartType !== 'default' && isMobilePhone()){

                  // this.props.renderStageCanvasToImg()
                  this.stageCanvasPrint();

                  return;

                } else {

                  hideProductTour({ fromWhere: 'B', withLastStepNotify: true});
                  setPrintModalVisible(true);

                }

              }
            }
          }
          >
        </div>
      </div>
    );
  }
}

export default PrintTree;
